import Client from "../../views/Client";

const ClientPage = () => {
  return <Client />;
};

export default ClientPage;
